import React from 'react';
import mt from 'moment-timezone';
import { DATETIME_DISPLAY } from 'components/utils/constants';
import { formatLocation, formatCopyright, formatDuration } from 'components/utils/helpers';
import searchTermsSection from 'components/elements/common/searchterm/SearchTermSection';

const VideoInfo = ({ id, title, seriesTitle, caption, format, searchTerms, publishedDate, copyright, city, state, country }) => {
  const formattedLocation = formatLocation(city, state, country);
  return (
    <div className="video-detail-info">
      <h1 dangerouslySetInnerHTML={{ __html: title }} />

      <figcaption dangerouslySetInnerHTML={{ __html: caption }} />

      <div className="video-detail-info-categorization">
        {Object.keys(searchTerms || {}).map(key => searchTermsSection(key, searchTerms, 'video'))}
      </div>

      <div className="video-detail-info-information">
        <h4>Information</h4>
        {seriesTitle && <span>Series: {seriesTitle}</span>}
        <span>Date published: {mt(publishedDate).format(DATETIME_DISPLAY)}</span>
        <span>Id: {id}</span>
        {format && format.duration && <span>Duration: {formatDuration(format.duration)}</span>}
        {format && format.frameSize && <span>Frame Size: {format.frameSize}</span>}
        {format && format.frameRate && <span>Frame Rate: {format.frameRate}</span>}
        {format && format.aspectRatio && <span>Aspect Ratio: {format.aspectRatio}</span>}
        {formattedLocation && <span>Location: {formattedLocation}</span>}
        <span>Copyright: {formatCopyright(copyright)}</span>
      </div>
    </div>
  );
};

export default VideoInfo;
